<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	data() {
		return {
			rowClick: (item) => {
				this.$router.push({ name: 'ProUserDetail', params: { id: item._id } })
			},
			items: [
				{ header: 'Prénom', value: (item) => item.firstName, sort: 'firstName', filter: { name: 'firstName'}},
				{ header: 'Nom', value: (item) => item.lastName, sort: 'lastName', filter: { name: 'lastName'} },
				{ header: 'Email', value: (item) => item.mail, sort: 'mail', filter: { name: 'mail'}},
				{ header: 'Telephone', value: (item) => item.phone, sort: 'phone', filter: { name: 'phone'} }
			]
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/proUsers/proUser.list.vue